import { useCallback, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

import ACFFieldGroupForm from "../../../components/ACF/ACFFieldGroupForm";
import Loader from "../../../components/Loader";
import TabHeader from "../components/TabHeader";

import fields from "../../../acf-json/group_626b3d8908371.json";
import { myCommsPrefsQuery } from "../services/userCommsPrefsQuery";
import { transformCheckboxValues } from "../../../components/ACF/acfHelpers";
import { updateUserMutation } from "../../../services/wp.user.service";
import { useAuth } from "../../../services/wp.auth.service";
import { useNotifications } from "../../../components/NotificationsContext";

const MyAccountCommunications = () => {
	const { user } = useAuth();
	const { addNotification } = useNotifications();
	const queryClient = useQueryClient();

	const [loading, setLoading] = useState(false);

	const {
		data: commsPrefs,
		isLoading
	} = myCommsPrefsQuery(useQuery, user.databaseId);

	const {
		mutateAsync: updateUser
	} = updateUserMutation(useMutation);

	const onSubmit = useCallback(async (communicationPreferences) => {
		setLoading(true);
		try {
			await updateUser({
				id: user.databaseId,
				communicationPreferences: transformCheckboxValues(communicationPreferences)
			});
			await queryClient.refetchQueries(["my_comms_preferences"]);
			addNotification({
				message: "Communication preferences updated successfully.",
				type: "success"
			});
		} catch (error) {
			addNotification({
				message: error.message,
				type: "danger"
			});
		}
		setLoading(false);
	}, [setLoading]);

	return (
		<>
			<TabHeader
				description="These are your contact settings"
				title="Communications"
			/>

			{
				isLoading
					? <Loader height="200px" width="auto" />
					: (
						<ACFFieldGroupForm
							fields={fields}
							formValues={commsPrefs}
							loading={loading}
							onSubmit={onSubmit}
						/>
					)
			}
		</>
	);
};

export default MyAccountCommunications;
